import React from "react";
import { useIntl } from "react-intl";
import FormWrapper from "./FormWrapper";
import { Row, Col, Button } from "antd";
import { InputItem, TextAreaItem } from "../../../forms/FormItems";
import { useSelector } from "react-redux";
import DateAndHourItem from "../../../forms/DateAndHourItem";
import ResponsiveItemsWrapper from "../../../layouts/ResponsiveItemsWrapper";
import Spacer from "../../../layouts/Spacer";
import { useActivity } from "../../hooks/useActivity";
import ActivityWrapper from "./index.style";

const Event = ({
  createActivity,
  refreshFormTimestamp,
  values,
  onChange,
  stretched,
  sider,
}) => {
  const intl = useIntl();
  const profileId = useSelector((state) => state.user.profile.user);
  const createLoading = useSelector(
    (state) => state.pendingActions["activity/create"]
  );
  const {
    disabledStartDate,
    disabledEndDate,
    disabledStartHours,
    disabledStartMinutes,
    disabledEndHours,
    disabledEndMinutes,
  } = useActivity(values);

  const onSubmit = (values) => {
    const activity = {
      ...values,
      assigned_to_id: profileId,
    };
    const val = {
      activity,
      activityType: "events",
    };
    createActivity(val);
  };

  const DateAndHourItems = () => (
    <>
      <DateAndHourItem
        required={true}
        name="start_time"
        category="event"
        disabledDate={disabledStartDate}
        disabledMinutes={disabledStartMinutes}
        disabledHours={disabledStartHours}
        even={true}
      />
      <DateAndHourItem
        required={true}
        name="end_time"
        category="event"
        disabledDate={disabledEndDate}
        disabledMinutes={disabledEndMinutes}
        disabledHours={disabledEndHours}
        even={true}
      />
    </>
  );

  return (
    <ActivityWrapper className="activity_form">
      <FormWrapper
        onSubmit={onSubmit}
        onChange={onChange}
        refreshFormTimestamp={refreshFormTimestamp}
      >
        <div className="form_padding">
          <Row>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              xxl={stretched ? 24 : 16}
            >
              <InputItem name="subject" category="event" required={true} />
              <TextAreaItem name="body" id={true} category="event" rows={4} />
              {sider ? (
                <DateAndHourItems />
              ) : (
                <ResponsiveItemsWrapper isSmall={true}>
                  <div className="item_half_width">
                    <DateAndHourItems />
                  </div>
                  <Spacer horizontal={true} />
                </ResponsiveItemsWrapper>
              )}
              <Button htmlType="submit" type="primary" loading={createLoading}>
                {intl.formatMessage({
                  id: "app.actions.submit",
                })}
              </Button>
            </Col>
          </Row>
        </div>
      </FormWrapper>
    </ActivityWrapper>
  );
};

export default Event;
